import DateFnsUtils from '@date-io/date-fns';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import React from 'react';

import { INVALID_DATE, MAX_DATE } from '../../utilities/constants';
const useStyles = makeStyles({
  dateCalendar: {
    borderRadius: 4,
    height: 44,
    marginBottom: 0,
    '&.MuiFormControl-root.MuiTextField-root.MuiFormControl-marginNormal': {
      marginTop: 0,
      '& .MuiInputBase-root': {
        borderRadius: '4px',
        padding: '12px 0px 12px 16px',
        width: 270,
      },
    },
  },
});
interface IInputProps {
  disabled: boolean;
  id: string;
  maxDate: Date;
  title: string;
  value: Date;
  minDate?: Date;
  errorInvalid?: boolean;
  maxDateError?: boolean;
  requiredDate?: boolean;
}
interface Props {
  InputProps: IInputProps;
  inputClass: string;
  labelClass: string;
  onChange: (event: MaterialUiPickersDate) => void;
  tooltipTitle: string | undefined;
  name: string;
  onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
}

const Calender: React.FC<Props> = ({
  InputProps,
  inputClass,
  labelClass,
  onChange,
  tooltipTitle,
  onKeyDown,
}: Props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      {InputProps.title &&
        (tooltipTitle ? (
          <Tooltip title={tooltipTitle}>
            <label className={labelClass || ''}>{InputProps.title}</label>
          </Tooltip>
        ) : (
          <label className={labelClass || ''}>{InputProps.title}</label>
        ))}
      <div className={'pr-0 pl-0 ' + inputClass || ' col-lg-12 col-sm-12'}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            disableToolbar
            disabled={InputProps.disabled ? InputProps.disabled : false}
            autoOk={true}
            variant="inline"
            format="yyyy/MM/dd"
            margin="normal"
            placeholder="YYYY/MM/DD"
            id={InputProps.id}
            minDate={InputProps.minDate ? InputProps.minDate : new Date(0)}
            maxDate={InputProps.maxDate}
            error={InputProps.requiredDate || InputProps.errorInvalid || InputProps.maxDateError}
            helperText={
              InputProps.requiredDate
                ? 'Required'
                : InputProps.errorInvalid
                ? INVALID_DATE
                : InputProps.maxDateError
                ? MAX_DATE
                : ''
            }
            value={InputProps.value}
            onChange={event => onChange(event)}
            onKeyDown={onKeyDown}
            KeyboardButtonProps={{
              'aria-label': 'change date',
              color: 'primary',
            }}
            className={classes.dateCalendar}
          />
        </MuiPickersUtilsProvider>
      </div>
    </React.Fragment>
  );
};

export default Calender;
